/* eslint-disable */
export default {
  schedule: 'Programar una reunión',
  prompt: 'Autorice a RingCentral a acceder a la información de la cuenta.',
  saveAsDefault: 'Guardar como configuración por defecto',
  launchMeeting: 'Iniciar reunión',
} as const;

// @key: @#@"schedule"@#@ @source: @#@"Schedule Meeting"@#@
// @key: @#@"prompt"@#@ @source: @#@"Please authorize RingCentral to access your account information."@#@
// @key: @#@"saveAsDefault"@#@ @source: @#@"Save as default"@#@
// @key: @#@"launchMeeting"@#@ @source: @#@"Launch Meeting"@#@
